import axios from 'axios';

export class AircraftCategoryService {

async getAllAircraftCategory() {
    try {
        const response = await axios.post('GetAllAircraftCategory');
        return response.data;
    } catch (error) {
        throw new Error("Error: " + error);
    }
}
}